import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { getDimensionTree } from '../components/utils'
import { getDimensionOptions } from './getDimensionOptions'

export const useCtxDimensionTree = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const options = getDimensionOptions(companyId, getDimensionTree)
  return useQuery(options)
}
